import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

import SubPageLayout from "reusables/layouts/SubPageLayout";

import School_Section1 from "./sections/School_Section1";

function SchoolCleaning() {
  usePageMeta({
    title: "School Cleaning Services Ireland | Spechs",
    description:
      "Professional school and educational facility cleaning across Ireland. Safe, compliant, reliable.",
    canonical: "https://www.spechs.ie/cleaning/school/",
  });
  return (
    <SubPageLayout title="School & Educational Facility Cleaning">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <School_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default SchoolCleaning;
